export const dummyAdvancePaymentBillData = {
    discoCode: null,
    brandPrefix: null,
    useSplitBrand: true,
    companyTitle: null,
    companyShortName: null,
    gstNo: null,
    gstLabel: null,
    website: null,
    referenceNo: null,
    consumerId: null,
    consumerName: null,
    address: null,
    transformer: null,
    feeder: null,
    subDivision: null,
    category: null,
    status: null,
    tariffCategory: null,
    sanctionedLoad: null,
    mdi: null,
    tariff: null,
    billMonth: null,
    readingDate: null,
    issueDate: null,
    dueDate: null,
    payableWithinDueDate: null,
    lpSurcharge: null,
    payableAfterDueDateTill: null,
    payableAfterDueDateAfter: null,
    meterFactor: null,
    previousReading: null,
    presentReading: null,
    units: null,
    meterNo: null,
    meterImageUrl: null,
    meterImageFit: 'cover',
    meterImagePosition: 'center center',
    meterSnapCapturedBy: null,
    meterSnapCapturedAt: null,
    meterSnapReference: null,
    meterSnapGps: null,
    meterSnapVersion: null,
    amountPaidNote: null,
    meterNote: null,
    totalElectricityCharges: null,
    subsidies: null,
    netElectricityCharges: null,
    netElectricityPercent: null,
    taxes: null,
    taxesPercent: null,
    currentBill: null,
    arrears: null,
    installment: null,
    adjustments: null,
    totalFpa: null,
    grandTotal: null,
    lpSurchargeAfter: null,
    surchargeTillDate: null,
    surchargeAfterDate: null,
    fpaMessageUrdu: null,
    noticeUrdu: null,
    billMessagesLayoutOnly: true,
    hideQrContent: false,
    hideHeaderUrduText: false,
    deferredAmount: null,
    outstandingInstallments: null,
    showPaidStamp: false,
    headerQrUrdu: null,
    sidebarQrUrdu: null,
    subsidyEligibilityUrl: null,
    barcodeRaw: null,
    barcodeCaption: null,
    raastQr: null,
    billHistory: [],
};
